var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_9",
    "data-name": "Layer 9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:#f2f2f2;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-7{stroke:#000;stroke-linecap:round;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke-linejoin:round;}.cls-1,.cls-2,.cls-3,.cls-5,.cls-7{stroke-width:5px;}.cls-2{fill:#668bff;}.cls-3,.cls-4,.cls-7{fill:none;}.cls-4{stroke-width:8.23px;}.cls-7{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "671.54 924.38 671.54 890.63 510.29 890.63 510.29 1190.63 671.54 1190.63 671.54 924.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1082.43,1200H117.57c12.5-45.27,48.09-161,89.61-179.38,51.58-22.74,273.43-87.22,275.6-87.86h0l23.75-7.14-.9,2.35c-.12.33-.26.69-.42,1.11-1.48,3.83-4.59,11.93-11.18,29,0,.07-.05.13-.06.19-.16.39-.3.79-.42,1.18-3.13,9.32-1.65,18.91,2.28,28.07a77.37,77.37,0,0,0,6.78,12.26,116.23,116.23,0,0,0,7.67,10.21,204,204,0,0,0,21,21.11l0,0q.69.63,1.35,1.2s0,0,.08.06l5.08,4.46a22.68,22.68,0,0,1,2.23,2.26h0a1.18,1.18,0,0,1,.18.21,41,41,0,0,1,8,16.19,1.24,1.24,0,0,0,0,.16,53.78,53.78,0,0,1,1.7,12.4,36.36,36.36,0,0,1-2.17,13.77,51.35,51.35,0,0,0-2.72,18.41v.22c.25,15.9,5.54,32.07,7.87,38.48a.26.26,0,0,0,0,.1c.65,1.78,1.06,2.79,1.06,2.79l33.54,34.78.21.22,2.83-14.16c.29-1.38.59-2.92.92-4.6.7-.84,1.34-1.69,1.94-2.57,14.31-20.7,3.5-48.83,3.08-49.89a.06.06,0,0,1,0,0l20-55,.12-.11,28.92-26,8.46-7.61c6.27-2.89,12.13-7.75,17.5-13.7,1.39-1.53,2.74-3.13,4.05-4.78a131.39,131.39,0,0,0,7.85-11.06C699,963,708.31,934,708.31,934s300.08,71.38,321.35,96.65C1046.53,1050.68,1072.44,1157,1082.43,1200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M641.31,1027.11c11.48-11.49,25.23,14.77,21.48,23.51s-10.42,26.26-10.42,26.26,52.92-40,55.42-52.5,6.25-48.76,6.25-82.5c0,0-4-17.5-42.61-17.5,15.23,7.5,21.78,41.75,15.32,56.5S641.31,1027.11,641.31,1027.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M540.29,1039.38c-18.75-3.76-27,24.76-23.75,35s7.84,25.43,7.84,25.43-48.46-50.91-54.52-64.06c-5.82-12.63-10-29.3-7.07-67.63,0,0,6.37-45.6,47.5-42.5-16.85,7.3-19.91,45.16-14.3,62.43S540.29,1039.38,540.29,1039.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.17,921.88v78.89s16-6.89,16.73-41S672.17,921.88,672.17,921.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M674.67,924.38c24.37,0,19.37,57.5.62,72.5s-58.75,53.74-58.75,53.74l-20,55s8.75,27.5,0,43.76-8.75,26.24-8.75,26.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M530.19,1030c6.35,6.85,26.35,21.85,17.6,51.85s6.25,58.74,6.25,60,33.75,35,33.75,35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.29,925.62v78.9s-16-6.89-16.73-41S510.29,925.62,510.29,925.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209,1138.12s21.34,31.22,30.05,61.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M947.49,1200c8.73-30.66,30-61.88,30-61.88"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M782.79,658.75c0,146.7-53.75,265.63-202.5,265.63s-202.5-118.93-202.5-265.63,47.5-275.63,202.5-275.63S782.79,512.05,782.79,658.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M782,627.17s47-4,47,47.21-53.46,70.71-53.46,70.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.61,627.17s-47-4-47,47.2S384,745.09,384,745.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 497.79,
    cy: 624.38,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 659.67,
    cy: 625,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M434.67,586.25Q454,515.3,512.17,555"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M713.42,586.25Q694.06,515.3,635.92,555"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M580.29,666.88a28.75,28.75,0,1,0,0,57.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M639.71,821.6c-10.47,5.5-25.24,9.69-45.67,11.52-22,2-38.71,0-51-4.31-42.24-14.76-33.6-56.81-15.22-60.69,23.53-5,35,18.76,58.75,13.76s46.25-25,60-22.5C657.42,761.35,679.22,800.82,639.71,821.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M639.71,821.6c-10.47,5.5-25.24,9.69-45.67,11.52-22,2-38.71,0-51-4.31,9-15.39,28-25.81,44.78-26.93C603.56,800.82,629,810.36,639.71,821.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M408.52,322.77a53.46,53.46,0,0,0,10.64-22,52.73,52.73,0,0,1,2.57-8.55l-26.46,6.11c7.57-13.95,16.07-28.77,30.55-35.06,7.36-3.21,15.29-3.8,23.32-2.8a77.77,77.77,0,0,1,11.09-5.76A108.23,108.23,0,0,1,492,247a99.93,99.93,0,0,1-13.54-15.3c17.68,5.83,36.72-2.74,54.92.8a44.72,44.72,0,0,1,27.39,17.95c9.1,1,18.2,1.8,27.33,2.11,2.66.09,5.32.13,8,.14,6.53-6.17,15.89-9.38,25.06-10.29,11.9-1.17,24,.89,36,1.47s24.64-.56,34.41-7.29a68,68,0,0,1-16.12,18.09c15.38,3,30.31,8.87,42.3,18.73a38.62,38.62,0,0,1,18.45,6.68c8.27,5.51,14.85,13.19,21.71,20.42s14.33,14.29,23.49,17.95a40.68,40.68,0,0,1-18.72,6.36c8.31,6,17.37,11.07,25.27,17.66,8.6,7.17,14.23,16.85,18.92,27.35,7.42-1.35,15.21-2.59,22.41,0C840,373.75,846.31,385,851,395.54s9.18,22.09,18.69,28.56a86,86,0,0,1-46.77-16.67,69.14,69.14,0,0,0,12,16.74c18.23,18.14,20.4,46.88,16.93,72s-11.33,49.89-8.71,75.29q.3,2.74.7,5.5a27,27,0,0,1,7.64,12.61c2.09,7.11,2.06,14.59,3,21.91s3.13,15,8.53,20.07a41.53,41.53,0,0,1-22.74-9,19.84,19.84,0,0,1-8.51,6.49c-5,2-10.64,1.65-16,2.07-28.51,2.18-52.85,27.4-54.36,56.31-9.57-30.08-1.18-62,4.38-92.58,4.62-25.42,6.51-53.88-4.3-76.94a29.65,29.65,0,0,1-12.07,11.79c5.13-5.17,7.4-12.54,7.45-20.09h0v0c-1.14-1.74-2.38-3.41-3.7-5.07C728,473,711.87,435.6,687.19,403.77c-10,8.12-13.82,23.14-9.05,35.56a56.28,56.28,0,0,1-24.3-43.59c-5.28,22.44-27.38,39.08-50.36,37.92a53.93,53.93,0,0,0,21.85-38c-10.37-5.54-21.2-10.67-32.7-12.34s-23.92.55-32.36,8.3-11.63,21.66-5.43,31.75a27.89,27.89,0,0,1-20.08-16.55,26.9,26.9,0,0,1,2.89-25.53c-20.39,1.41-35.55,18.4-47.29,35s-23.55,35.09-42.61,42.09q7.92-15.92,15.8-31.83c-13.87.49-25.6,10.75-32.07,23s-8.74,26.32-11.35,40.05-3.43,24.94-11.72,35.95c-11.6,15.37-14.48,35-14,55,0,.14,0,.29,0,.43A286.38,286.38,0,0,0,397,610c3.83,29.17,8.25,60.71-5.76,85.9-1.91-17.35-19-32-36.13-30.91-7.89.48-15.54,3.81-23.42,2.72-9.16-1.3-16.85-8.57-21.05-17s-5.48-17.94-6.36-27.25c-.11-1.11-.21-2.23-.29-3.34L292.6,626c4.89-11.23,4.68-24.09,5.37-36.46.45-8.29,1.51-16.92,4.62-24.41.27-11.77.87-23.51,1.64-35.23a100.86,100.86,0,0,1-16,11.36c1.11-24.49,2.29-49.32,9.82-72.4,5.42-16.59,14.58-32.38,27.42-43.62,1.49-12.54,2.82-25.08,8.31-36.2a59.54,59.54,0,0,1,10-14.17,50.17,50.17,0,0,1-13.33-7c13.8-11.06,27.66-22.19,43-31A126.16,126.16,0,0,1,408.52,322.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M762.65,324.85c8.31,6,17.37,11.07,25.27,17.66,8.6,7.17,14.23,16.85,18.92,27.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M560.81,250.48c9.1,1,18.2,1.8,27.33,2.11,2.66.09,5.32.13,8,.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408.52,322.77a53.46,53.46,0,0,0,10.64-22,52.73,52.73,0,0,1,2.57-8.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M304.23,529.87c-.77,11.72-1.37,23.46-1.64,35.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M822.89,407.43a69.14,69.14,0,0,0,12,16.74c18.23,18.14,20.4,46.88,16.93,72s-11.33,49.89-8.71,75.29q.3,2.74.7,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M304,620.07c.08,1.11.18,2.23.29,3.34.88,9.31,2.15,18.81,6.36,27.25s11.89,15.7,21.05,17c7.88,1.09,15.53-2.24,23.42-2.72,17.13-1.07,34.22,13.56,36.13,30.91,14-25.19,9.59-56.73,5.76-85.9a286.38,286.38,0,0,1-2.58-29c0-.14,0-.29,0-.43-.51-20,2.37-39.64,14-55,8.29-11,9.1-22.22,11.72-35.95s4.87-27.82,11.35-40.05,18.2-22.5,32.07-23q-7.91,15.92-15.8,31.83c19.06-7,30.88-25.48,42.61-42.09s26.9-33.61,47.29-35a26.9,26.9,0,0,0-2.89,25.53,27.89,27.89,0,0,0,20.08,16.55c-6.2-10.09-3-24,5.43-31.75s20.85-10,32.36-8.3,22.33,6.8,32.7,12.34a53.93,53.93,0,0,1-21.85,38c23,1.16,45.08-15.48,50.36-37.92a56.28,56.28,0,0,0,24.3,43.59c-4.77-12.42-1-27.44,9.05-35.56C711.87,435.6,728,473,753.14,504.45c1.32,1.66,2.56,3.33,3.7,5.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M761.46,517.85c10.81,23.06,8.92,51.52,4.3,76.94-5.56,30.61-14,62.5-4.38,92.58,1.51-28.91,25.85-54.13,54.36-56.31,5.4-.42,11-.12,16-2.07a19.84,19.84,0,0,0,8.51-6.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325.44,425.23v0c1.49-12.54,2.82-25.08,8.31-36.2a59.54,59.54,0,0,1,10-14.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M449.14,260.47a77.77,77.77,0,0,1,11.09-5.76A108.23,108.23,0,0,1,492,247"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M675.42,254.71c15.38,3,30.31,8.87,42.3,18.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M625.89,269.92a71.45,71.45,0,0,0,49.51-15.21h0a68,68,0,0,0,16.12-18.09c-9.77,6.73-22.41,7.86-34.41,7.29s-24.06-2.64-36-1.47c-9.17.91-18.53,4.12-25.06,10.29a27.36,27.36,0,0,0-5,6.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M566.11,260.35a43.29,43.29,0,0,0-5.3-9.87,44.72,44.72,0,0,0-27.39-17.95c-18.2-3.54-37.24,5-54.92-.8A99.93,99.93,0,0,0,492,247h0a100.32,100.32,0,0,0,39.58,22.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M478.81,269.49c-9.43-4.1-19.62-7.79-29.67-9-8-1-16-.41-23.32,2.8-14.48,6.29-23,21.11-30.55,35.06l26.46-6.11q23-5.34,46.08-10.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M423.62,320.66a93.35,93.35,0,0,0-15.1,2.11,126.16,126.16,0,0,0-35.11,14.09c-15.36,8.78-29.22,19.91-43,31a50.17,50.17,0,0,0,13.33,7c12.64,4.45,26.88,4,38.71-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.24,414.31a68.09,68.09,0,0,0-16.8,10.9c-12.84,11.24-22,27-27.42,43.62-7.53,23.08-8.71,47.91-9.82,72.4a100.86,100.86,0,0,0,16-11.36v0a100.51,100.51,0,0,0,16.47-18.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M308.85,555a34.45,34.45,0,0,0-6.26,10.06c-3.11,7.49-4.17,16.12-4.62,24.41-.69,12.37-.48,25.23-5.37,36.46l11.42-5.9,31.38-16.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M738.53,320a43,43,0,0,0,24.12,4.81,40.68,40.68,0,0,0,18.72-6.36c-9.16-3.66-16.64-10.71-23.49-17.95s-13.44-14.91-21.71-20.42a38.62,38.62,0,0,0-18.45-6.68,24.65,24.65,0,0,0-9.42,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M726.14,442.91c3.24,10.23,9.42,19.28,15.34,28.28s11.79,18.31,14.26,28.75a41.24,41.24,0,0,1,1.1,9.58v0h0c-.05,7.55-2.32,14.92-7.45,20.09a29.65,29.65,0,0,0,12.07-11.79c4-6.79,6.24-15.06,7.5-23,2.2-13.8,2.76-28.51,10-40.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.7,510.05c9.14,10.85,12.13,25.39,16.57,38.83,4.35,13.11,11.59,26.93,24.18,32.08.31.13.62.26.95.37-.33-.26-.65-.52-1-.8-7.78-6.67-10.93-17.79-10.22-28,.73-10.6,5-20.46,9.4-30s9-19.15,10.57-29.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M814.72,473.15c9.62,17.34,7.43,40.32-5.23,54.77,9.67-3.07,19.93-6.52,26.12-14.58,6.43-8.38,7.06-20,6.3-30.75s-2.69-21.75-.38-32.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M804.53,389.31a86.13,86.13,0,0,0,18.36,18.11h0a86,86,0,0,0,46.77,16.67c-9.51-6.47-14-18-18.69-28.56s-11-21.79-21.72-25.67c-7.2-2.6-15-1.36-22.41,0a1.91,1.91,0,0,0-.33.06c-7.57-2.93-10.53-7.08-14.69-14.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M824.15,596.73a43.62,43.62,0,0,0,16.14,25.77,41.53,41.53,0,0,0,22.74,9c-5.4-5.1-7.58-12.76-8.53-20.07s-.93-14.8-3-21.91a27,27,0,0,0-7.64-12.61,16.73,16.73,0,0,0-6.29-3.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M724.66,793.38l9.64,7.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M712.83,825.11l8.3,8.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M661.25,831l1.45,11.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M617.57,872.22l-1.18,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M665,876.87l6.4,10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M581.24,901.75l-6,10.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M565.81,844.69l-.16,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M525.78,885.26l-5.1,10.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M507.68,851l-1.4,11.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M441.05,841.82l6.85-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M470.51,799.87l2.94,11.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M408.91,769.09l11.14-4.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M741.18,758l11.6,2.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M724.07,415.37c-4.13-7.25-8.3-14.56-13.89-20.75s-12.81-11.25-21-12.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M717.8,302.36a334,334,0,0,1-49.67-2.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M597.61,297.15a23.26,23.26,0,0,1,25.4-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M579.15,283.5a38.14,38.14,0,0,1-35.17-16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M537.23,294.1c-23.81-10-54.14-.8-68.36,20.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M441.77,331.7a57.27,57.27,0,0,1-48.71,20.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401,379.91c-7,13.47-20.08,22.4-31.06,32.85s-20.65,25.05-17.29,39.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M334.19,527.39a61.68,61.68,0,0,1-13.66,34.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M363.74,597.9c-1.2,6.06,1.66,12.21,5.31,17.18s8.18,9.34,11.15,14.76,4.08,12.46.64,17.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M336.85,648.5a29.91,29.91,0,0,0,5.31-24.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M383.9,499.86a115.22,115.22,0,0,1,20.17-51.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.52,409.67q8.4-10.25,17.7-19.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M493.16,383.18a170.83,170.83,0,0,1-18.74,35.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M565,364.85c14.12-12.85,38.09-10,51.4-23.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M618.55,373.34a7.57,7.57,0,0,0-7.53-5.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M551.62,349.57a79.45,79.45,0,0,1-44-8.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M485.07,347.7a113,113,0,0,0-12.78,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M795.83,552.73a137.94,137.94,0,0,1-25.93,67.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M769.68,413.92a46,46,0,0,1,10.84,26.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M650.59,342.34c8.87-1.61,17.8,2.13,25.73,6.43s15.76,9.34,24.68,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M721.64,353.33c3.92,5.52,8,11.17,13.61,14.94s13.27,5.32,19.22,2.08"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar08);
export default __webpack_public_path__ + "static/media/Avatar-08.0f4d9bf805248e174e2db7d45395b309.svg";
export { ForwardRef as ReactComponent };